import React, { useRef } from "react";
import { Divider, Typography } from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";
import "../JaldiLab.css";
import ADAkneeroomdesign from "../../../assets/Images/Courtroom images/ADA-knee room design.gif";
import ADAtoeroomdesign from "../../../assets/Images/Courtroom images/ADA-toeroom design.gif";
import Image from "../../../components/ChapterImage/Image";
import RenderCourtrooms from "../../../assets/Images/Courtroom images/Renders_Courtroom.png";
import DetailJudges from "../../../assets/Images/Courtroom images/witnessImg.png";
import RenderCourtroomsPDJ from "../../../assets/Images/Courtroom images/Renders_Courtroom_UserGroupB.png";
import CourtroomPDJ from "../../../assets/Images/Courtroom images/Courtroom-01.png";
import CourtroomTypeB from "../../../assets/Images/Courtroom images/Render_CourtroomTypeB.png";
import RenderPocso from "../../../assets/Images/Courtroom images/Renders_Pocso_new.png";
import {
  paraStyle,
  pointStyle,
  h1style,
  h2style,
  h3style,
  h4style,
  subHeadingStyle,
  dimensionStyle,
  sectionStyle,
  getTextContentHeading,
  generateOrderedList,
  textDecorationStyle,
  getCircleTypeListItem,
  getTextContentHeadingImg,
  DividerBorderStyle,
  referenceStyle,
  referenceTootKit,
  referenceHtml,
  customHeading4,
  tableCaption,
  getHeadingContent,
  orderListHeading,
  subHeadingContent,
} from "./ChapterList";
import {
  Table3,
  Table4,
  Table5,
  Table6,
} from "./CourtRoomTables/CourtRoomsTables";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import objective from "../../../assets/SvgIcons/obj.svg";
import user from "../../../assets/SvgIcons/users.svg";
import adjacencies from "../../../assets/SvgIcons/adjacencies.svg";
import designConsideration from "../../../assets/SvgIcons/design-consideration.svg";
import districtHierarchy from "../../../assets/Images/Courtroom images/districtHierarchy.jpg";
import pocsoCourtroom from "../../../assets/Images/Courtroom images/pocsoCourtroom.png";
import courtroomTypeA from "../../../assets/Images/Courtroom images/Render_CourtroomTypeA.png";
import courtroomCabin1 from "../../../assets/Images/Courtroom images/courtroomCabin1.png";
import courtroomCabin2 from "../../../assets/Images/Courtroom images/courtroomCabin2.png";
import {
  FigureDesc34,
  FigureDesc35,
  FigureDesc36,
  FigureDesc37,
  FigureDesc38,
  FigureDesc39,
  FigureDesc40,
  ImageDesc50
} from "../../../utils/tmp/ImageDescription/CourtroomID";

const CourtRoomsPage = ({ goToSection }) => {
  const referencesRef = useRef(null);

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };

  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };

  const referenceData = [
    {
      content:
        <>‘Americans with Disabilities Act: Accessibility Standards’ <i>(U.S. Access Board)</i></>,
      link: "https://www.access-board.gov/ada/#ada-306",
      description:
        " <https://www.access-board.gov/ada/#ada-306> [“ADA Accessibility Standards”]. See also: Harmonised Guidelines 2021, section 4.13.3.",
    },
    {
      content:
        "e-Committee of Supreme Court of India, ‘Model Rules for Video Conferencing for Courts’ (2020) ",
      link: "https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2020/08/2020082629.pdf",
      description:
        "<https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2020/08/2020082629.pdf> [“Model Video Conferencing Rules”]",
    },
    {
      content:
        " e-Committee of Supreme Court of India, ‘Model Rules for Live Streaming and Recording of Court Proceedings’ (2020) ",
      link: "https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2021/06/2022091599.pdf",
      description:
        "<https://cdnbbsr.s3waas.gov.in/s388ef51f0bf911e452e8dbb1d807a81ab/uploads/2021/06/2022091599.pdf> [“Model Live Streaming Rules”]",
    },
    {
      content: "NCMS (2012). ",
    },
    {
      content: "‘ADA Accessibility in the Courtroom’ (Lift-U)",
      link: "https://www.lift-u.com/wp-content/uploads/2018/05/LU0018-2017-Courtrooms-CEU-COURSE-2017-Rev-E.pdf",
      description:
        "  <https://www.lift-u.com/wp-content/uploads/2018/05/LU0018-2017-Courtrooms-CEU-COURSE-2017-Rev-E.pdf> [“ADA Courtroom Accessibility”]",
    }, //97
    {
      content: "Narcotic Drugs and Psychotropic Substances Act (1985), s 36. ",
    }, //98
    {
      content:
        "Scheduled Caste and Scheduled Tribe (Prevention of Atrocities) Act (1989), s 16.",
    }, //99
    {
      content: "National Investigation Agency Act (2008), s 11.",
    }, //100
    {
      content: "Commercial Courts Act (2015), s 3.",
    },
    {
      //101
      content:
        "Juvenile Justice (Care and Protection of Children) Act (2015), s 4.",
    }, //102
    {
      content: "Family Courts Act (1984), s 3. ",
    }, //103
    {
      content:
        "The Protection of Children from Sexual Offences (POCSO) Act (2012), s 2(d). [“POCSO Act”]",
    }, //104
    {
      content: " POCSO Act, s 38. ",
    }, //105
  ];

  const tableHeading = {
    color: "#000",
    fontSize: "1rem",
    fontWeight: 600,
    paddingRight: "5px",
  };

  const POCSOData = [
    {
      sectionNo: "S. 26",
      sectionTitle: "Additional provisions regarding statement to be recorded",
      sectionDetails: [
        "1. The Magistrate or the police officer, as the case may be, shall record the statement as spoken by the child in the presence of the parents of the child or any other person in whom the child has trust or confidence. 2. Wherever necessary, the Magistrate or the police officer, as the case may be, may take the assistance of a translator or an interpreter, having such qualifications, experience and on payment of such fees as may be prescribed, while recording the statement of the child. 3. The Magistrate or the police officer, as the case may be, may, in the case of a child having a mental or physical disability, seek the assistance of a special educator or any person familiar with the manner of communication of the child or an expert in that field, having such qualifications, experience and on payment of such fees as may be prescribed, to record the statement of the child. 4. Wherever possible, the Magistrate or the police officer, as the case may be, shall ensure that the statement of the child is also recorded by audio-video electronic means.",
      ],
      designConsiderations: [
        <>
          Adequate space must be provided for the presence of the parents of the
          child or any other support persons such as a translator, interpreter,
          special educator or any other expert / person familiar with the
          child’s manner of communication. Provision must be made for seating
          and other amenities for all such support persons, to enable recording
          of evidence. Audio-visual facilities and other digital means of
          recording evidence must be provided.
        </>,
      ],
    },
    {
      sectionNo: "S. 28",
      sectionTitle: "Designation of Special Courts",
      sectionDetails: [
        "1. For the purposes of providing a speedy trial, the State Government shall in consultation with the Chief Justice of the High Court, by notification in the Official Gazette, designate for each District, a Court of Session to be a Special Court to try the offences under the Act.",
      ],
      designConsiderations: [
        "The Special Court must be a comfortable, non-intimidating space where the child victim may be able to give their statement and hearings may be conducted in a sensitive manner.",
      ],
    },
    {
      sectionNo: "S. 33",
      sectionTitle: "Procedure and powers of Special Court",
      sectionDetails: [
        "4. The Special Court shall create a child-friendly atmosphere by allowing a family member, a guardian, a friend or a relative, in whom the child has trust or confidence, to be present in the Court. 7. The Special Court shall ensure that the identity of the child is not disclosed at any time during the course of investigation or trial. Explanation.--For the purposes of this sub-section, the identity of the child shall include the identity of the child's family, school, relatives, neighbourhood or any other information by which the identity of the child may be revealed.",
      ],
      designConsiderations: [
        <>
          Principles for child-friendly and trauma informed design have been
          outlined below. For further details, please refer to{" "}
          <span
            onClick={() => goToSection("vwdc", "vulnerable-witness")}
            style={sectionStyle}
          >
            Section 2.3.A.
          </span>{" "}
          Adequate provisions must be made for masking details relating to the
          child victim. For further details, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure3")}
          >
            Annexure 3.
          </span>
        </>,
      ],
    },
    {
      sectionNo: "S. 36",
      sectionTitle: "Child not to see Accused at the time of testifying",
      sectionDetails: [
        "1. The Special Court shall ensure that the child is not exposed in any way to the Accused at the time of recording of the evidence, while at the same time ensuring that the Accused is in a position to hear the statement of the child and communicate with his Advocate. 2. For the purposes of sub-section (1), the Special Court may record the statement of a child through video conferencing or by utilising single visibility mirrors or curtains or any other device.",
      ],
      designConsiderations: [
        "The Special Court must have provisions for single-visibility mirrors, curtains, or any other such separative device, to ensure that the child victim does not come into contact with the Accused at the time of giving testimony. The Special Court, the POCSO waiting area for the child victims, and the separate waiting area for the Accused must be equipped with video-conferencing facilities.",
      ],
    },
    {
      sectionNo: "S. 37",
      sectionTitle: "Trials to be conducted in camera",
      sectionDetails: [
        "The Special Court shall try cases in camera and in the presence of the parents of the child or any other person in whom the child has trust or confidence.",
      ],
      designConsiderations: [
        "Provisions must be made for masking the identity of the child and for ensuring digital privacy.",
      ],
    },
    {
      sectionNo: "S. 39",
      sectionTitle: "Guidelines for child to take assistance of experts, etc.",
      sectionDetails: [
        "Subject to such rules as may be made in this behalf, the State Government shall prepare guidelines for use of non-governmental organisations, professionals and experts or persons having knowledge of psychology, social work, physical health, mental health and child development to be associated with the pre-trial and trial stage to assist the child.",
      ],
      designConsiderations: [
        "Adequate space and amenities must be provided for the use of non-governmental organisations, professionals, experts or any other support persons present at the stage of trial before the Special Court.",
      ],
    },
  ];

  const courtHearsObject = {
    data: [
      "Civil cases",
      "Criminal cases",
      "Cases under special legislations such as the Protection of Children from Sexual Offences (POCSO) Act (2012), Family Courts Act (1984), Motor Vehicles Act (1988), Narcotic Drugs and Psychotropic Substances (NDPS) Act (1985), etc.",
    ],
  };

  const courtroomCategory = [
    <>
      <span style={{ ...tableHeading, ...textDecorationStyle }}>
        Multipurpose Courtrooms:{" "}
      </span>{" "}
      Typical Courtrooms which would be used for both civil and criminal cases.
    </>,
    <>
      <span style={{ ...tableHeading, ...textDecorationStyle }}>
        Speciality Courtrooms:{" "}
      </span>{" "}
      Specially-designed Courtrooms catering to the specific requirements of
      special legislations such as POCSO, NDPS, etc.
    </>,
  ];

  const objectives = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        <span style={{ color: "#DC002D" }}>
          Ensure accessibility for diverse users
        </span>{" "}
        including Persons with Disabilities, the elderly, expectant mothers,
        children, etc. through the incorporation of universal design in the
        Courtroom;
      </>,
      <>
        Design the Courtroom to{" "}
        <span style={{ color: "#DC002D" }}>ensure accessibility for all</span>{" "}
        by not having any level difference between spaces such as the dais,
        witness box, etc.;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Ensure flexibility in the design
        </span>{" "}
        of the Courtroom for future expansion depending on the future needs;
      </>,
      <>
        Ensure that the Courtroom has a{" "}
        <span style={{ color: "#DC002D" }}>
          safe and efficient layout with adequate space for all users
        </span>{" "}
        to perform their specific roles, which includes the provision of
        separate access points for the Judges, Advocates & parties, and the
        Accused (in criminal cases);
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Protect the witnesses and victims from confrontation
        </span>{" "}
        with the Accused, as well as other forms of intimidation;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Adopt adequate security and fire safety mechanisms
        </span>{" "}
        such as sprinklers, etc., and efficient operations & maintenance
        procedures;
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Design the Courtroom layout to be efficient
        </span>{" "}
        for all stakeholders who are part of the ongoing proceedings, by
        ensuring they are clearly visible to each other at all times through the
        use of effective sightlines;
      </>,
      <>
        Design acoustics for the courtroom to ensure{" "}
        <span style={{ color: "#DC002D" }}>
          speech privacy and speech intelligibility
        </span>
        , with sufficient acoustically absorptive materials and isolation; and
      </>,
      <>
        <span style={{ color: "#DC002D" }}>
          Enhance the efficiency of the Court processes
        </span>{" "}
        by integrating video conferencing facilities and other audio-visual
        equipment for online as well as hybrid proceedings, as required.
      </>,
    ],
    isOrdered: false,
    isImage: true,
  };

  const usersObject = {
    icon: <img src={user} />,
    heading: "Users of the Courtroom",
    data: [
      "Judge",
      "Advocates",
      "Clerks",
      "Stenographer",
      "Interpreter",
      "Police Inspector",
      "Petitioner/plaintiff",
      "Respondent/Accused ",
      "Witnesses",
      "Government pleaders/Public prosecutors",
      "Others associated with the case/general public",
    ],
    isOrdered: false,
    isImage: true,
  };

  const adjacenciesObject = {
    icon: <img src={adjacencies} />,
    heading: "Adjacencies",
    data: [
      "Courtrooms must be in close proximity to staircases, lifts, and ramps to ensure easy movement for all stakeholders. ",
      "Courtrooms may be connected by dedicated staircases, lifts and ramps for Court staff and Advocates.  ",
      "All Courtrooms must be in close proximity or have direct access to public waiting areas.",
      "Each Courtroom must have direct access to the chambers of the Judge assigned to that particular Courtroom, or a Judges’ corridor leading to the chambers.",
      "All Courtrooms must have direct access to the associated Shirestedar’s Room and the Pending Branch connected with them. ",
      "The Courtrooms must be in  proximity or have access to a multi-person office space for the Court clerks to store their personal belongings and additional files/documents, etc., as required, beyond the time for which the Court is in session. ",
      "When multiple courtrooms are located on two sides of a corridor, the Courtroom entrance doors must not face each other directly, to ensure that adequate space and privacy is maintained. ",
    ],
    isOrdered: false,
    isImage: true,
  };

  const segregatedItem = [
    "Judges (restricted entry)",
    "Parties, Advocates, Court staff, and the general public (secure entry)",
    "Accused (secure entry)",
  ];

  const courtroomAdequate = [
    "A separate table and chair for the public prosecutor for criminal cases;",
    "Seating for the lawyers arguing the case; ",
    "Seating for interpreters/sign language interpreters and other support persons;",
    "Seating for the parties; and",
    "Seating for the general public and other users.",
  ];

  const additinallySpace = [
    "Adequate floor to ceiling concealed storage shelves for storing files and referral books, as required; and ",
    "Space on the lawyers’ desks for storing books and files.",
  ];

  const remotePointObect = {
    data: [
      "(i) Desktop, Laptop, mobile devices with internet connectivity and printer",
      "(ii) Device ensuring uninterrupted power supply;",
      "(iii) Camera;",
      "(iv) Microphones and speakers;",
      "(v) Display unit;",
      "(vi) Document visualizer;",
      "(vii) Provision of a firewall;",
      "(viii) Adequate seating arrangements ensuring privacy;",
      "(ix) Adequate lighting; and",
      "(x) Availability of a quiet and secure space. ",
    ],
    isOrdered: true,
  };

  const technologyEquipment = {
    data: [
      "Desktops, laptops and mobile devices with internet connectivity and printer;",
      "Device ensuring uninterrupted power supply;",
      "Cameras;",
      "Microphones and speakers;",
      "Display units;",
      "Document visualizer; and ",
      "Provision of a firewall. ",
    ],
    isOrdered: false,
  };

  const daisItem = [
    <>
      Judges (including space for two Judges, in the Courtroom of the Principal
      District Judge);{reference(referenceData[3], 4)}
    </>,
    "Bench clerk;",
    "Stenographer; and",
    "Other technical support persons, if necessary.",
  ];

  const designConsiderationsObject = [
    {
      icon: <img src={designConsideration} />,
      heading: "Design Considerations for All Courtrooms",
      items: [
        <>
          Segregated, secure and accessible entrances for the Courtroom must be
          provided in the following manner:
          {getCircleTypeListItem(segregatedItem, true)}{" "}
        </>,

        "The Courtroom must be clearly marked out with adequate signage and must be easily locatable for all users, especially parties or witnesses who may be unfamiliar with the Court Complex. ",

        "The name of the Judge assigned to that Court must be properly displayed outside the Courtroom.",

        "The entrance of the Courtroom must have adequate security and a digital display screen which continuously updates case progress as per the causelist.",

        <>
          The Courtroom must have adequate, comfortable and ergonomic seating
          for all stakeholders, including the following:{" "}
          {getCircleTypeListItem(courtroomAdequate, true)}
        </>,

        "Seating arrangements must be designed to optimise Courtroom dynamics, promoting orderly proceedings and respectful interaction, minimising distractions and disruptions.",

        "In such cases where multiple parties are involved, space should be provide to accommodate the multiple parties and their Advocates.",

        <>
          Additionally, space must be effectively utilised for storing relevant
          documents, which also takes into account the following:
          {getCircleTypeListItem(additinallySpace, true)}
        </>,

        "The flooring and walls of the Courtroom must be made of durable non-slip materials which require very little or no regular maintenance.",

        <>
          The Courtroom must be designed to achieve optimum acoustic ambience
          inside, and sufficient isolation between adjacent areas to avoid noise
          intrusion. For further details on acoustics, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure5")}
          >
            Annexure 5
          </span>
          .
        </>,

        <>
          Clear floor or ground space for turning of wheelchairs must
          additionally include accessible knee and toe clearance under the
          tables in the Courtroom.{reference(referenceData[0], 1)}
        </>,

        <>
          A clear knee space of about <span style={dimensionStyle}>750 mm</span>{" "}
          width, <span style={dimensionStyle}>680 mm</span> height above the
          finished floor level or ground and{" "}
          <span style={dimensionStyle}>480 mm</span> depth must be provided
          under any table. For a wheelchair user the width must be at least{" "}
          <span style={dimensionStyle}>900 mm</span>.
        </>,

        <>
          A clear toe space of <span style={dimensionStyle}>230 mm</span> above
          the finished floor level or ground and{" "}
          <span style={dimensionStyle}>150 mm</span> deep must be provided under
          any table.
        </>,

        "The Courtroom must be well-equipped with updated technology for video-conferencing, display of case progress, dashboards, etc., as required. ",

        "All positions within the Courtroom must be designed to ensure optimal viewing of fixed and mobile display technology.",

        <>
          The Supreme Court prescribed Model Rules for Video Conferencing for
          Courts in April 2020.{reference(referenceData[1], 2)} The following
          specific design considerations for the Courtroom must be kept in mind
          to ensure compliance with the rules:
          <div style={{ padding: "20px 0px 15px 0px" }}>
            <p className="table-guidance-heading">
              <span className="table-guidline-text">Table 3:</span>
              <br />
              <span style={tableCaption}>
                Design considerations arising from the Model Design
                considerations arising from the ModRules for Video Conferencing
                for Courts.
              </span>
            </p>
            <Table3 />
          </div>
        </>,

        <>
          Additionally, the Supreme Court adopted Model Rules for Live Streaming
          and Recording of Court Proceedings in September 2022.
          {reference(referenceData[2], 3)} The following specific design
          considerations for the Courtroom must be kept in mind to ensure
          compliance with the rules:{" "}
          <div>
            <p className="table-guidance-heading">
              <span className="table-guidline-text">Table 4:</span>
              <br />
              <span style={tableCaption}>
                Design considerations arising from the Model Rules for Live
                Streaming and Recording of Court Proceedings.
              </span>
            </p>
            <Table4 gotosection={goToSection} />
          </div>
        </>,
      ],
    },
    {
      heading: "Dais",
      items: [
        "The dais facilitates direct entry of the Judge into the Courtroom, as it is linked to the entrance to the Judge’s chamber.",

        "The dais must be designed to ensure that the Judges have optimum sightlines to all parts of the room.",

        <>
          The dais must be at a height of{" "}
          <span style={dimensionStyle}>450 mm</span> from the finished floor
          level. The clear height of the room above the dais must also take into
          account obstructing beams, etc.
        </>,

        "Ramp access must be provided, where space permits, with colour contrast on steps.",

        <>
          The dais must have a minimum width of{" "}
          <span style={dimensionStyle}>900 mm</span> vacant space for unhindered
          movement.
        </>,

        <>
          The dais must accommodate a{" "}
          <span style={dimensionStyle}>1500 mm</span> turning meter for a
          wheelchair.
        </>,

        <>
          Upon the dais, adequate seating must be provided for the following,
          with sufficient space for movement towards the sides and the rear of
          the dais: {getCircleTypeListItem(daisItem, false, "i")}
        </>,

        "The dais must accommodate the requisite technological facilities, including provision for a power outlet, computer LAN outlet, and video conferencing facilities.",
        "The placement of furniture and wires on the dais must not obstruct the movement of the Judges and the users. ",
      ],
    },
    {
      heading: "Witness Box and Accused Box",
      items: [
        "Within the Courtroom, space must be provided near the dais for a separate witness box (to be used at the time of deposition by the witness, in civil and criminal cases) and an enclosed Accused box (to be used by the Accused and accompanying police/security personnel in criminal cases). ",
        <>
          These boxes must be provided at the finished floor level, to avoid
          additional levels inside the Courtroom.
        </>,
        <>
          The witness box must comfortably accommodate a seating for the witness
          and a support person (if required), with consideration of a turning
          diameter of <span style={dimensionStyle}>1500 mm</span>.
        </>,

        "The Accused box must be provided with a bench capable of seating at least 3 persons.",

        <>
          In such cases, where the boxes are raised, the elevation must not be
          more than <span style={dimensionStyle}>150 mm</span> to{" "}
          <span style={dimensionStyle}>200 mm </span>from the finished floor
          level, with the provision of a ramp with{" "}
          <span style={dimensionStyle}>1:12</span> ramp ratio or platform lifts
          to ensure accessibility for diverse user groups.
          {reference(referenceData[4], 5)}
          <CaptionWithBorders1
            image={[courtroomCabin1, courtroomCabin2]}
            caption="Image 50: Examples of an accessible witness box and Accused box"
            creditLabel="Source"
            imageCredit="ADA Courtroom Accessibility"
            imageDescription={ImageDesc50}
          />
          <CaptionWithBorders1
            image={[DetailJudges]}
            isZoom={true}
            caption="Figure 35: Sectional elevation for the dais and the witness box"
            creditLabel="Source"
            imageCredit="Adapted from Draft California Trial Court Facilities Standards (2020)."
            zoomImgStyle={{ height: "650px" }}
            imageDescription={FigureDesc35}
          />
        </>,
      ],
    },
    {
      heading: "Evidence Desk",
      items: [
        <>
          A desk for showcasing physical evidence must be positioned in a secure area, where access can be controlled and restricted to authorised personnel only. The desk must be visible to all parties involved in the legal proceedings, including the Judges, Advocates, parties, witnesses, and the Accused. Hence, the evidence desk must be near the
          Judges zone where it is easily visible, but not easily accessible to
          unauthorised individuals as shown below in{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("figure39", "HeadingAnnexure4")}
          >
            {" "}
            Figures 36 and 39
          </span>
          .
        </>,

        "Adequate security measures must be provided to guard the evidence being displayed. The evidence desk must be provided with adequate seating for security personnel to control access to it. Further, surveillance cameras must be used to help control access.",

        <>
          Technology such as monitors or screens must be used to ensure that all
          parties are able to view the evidence without physically handling
          sensitive materials.
        </>,
      ],
    },
    {
      heading: "Seating for Public Prosecutor, Translators, etc.",
      items: [
        "Seating may be provided near the evidence desk for specialised individuals assisting the Court in different proceedings, allowing them to provide real-time assistance to the Court and other users during proceedings.",

        "In case of Criminal Courts, specific space must be apportioned for the Public Prosecutors/Special Public Prosecutor in close proximity to the Accused Box to facilitate easy communication. ",

        "In such cases where specialised support persons need to be engaged, space must be provided for such translators, interpreters, sign language interpreters, etc., while ensuring that they are in the sightlines of all the stakeholders within the Courtroom. ",
      ],
    },
  ];

  const specificItem = [
    <>
      <b>Judges:</b>
      <ul type="square">
        <li>
          Space must be provided on the dais for at least two Judges to sit
          comfortably.
        </li>
      </ul>
    </>,
    <>
      <b>Court Staff:</b>
      <ul type="square">
        <li>
          Space must be provided for stenographers and Court clerks on either
          side of the Judge; and
        </li>
        <li>
          Adequate space must be provided for the staff overseeing and
          controlling access to the evidence being presented during the
          proceedings.
        </li>
      </ul>
    </>,
    <>
      <b>Advocates, Parties, and Witnesses, and Support Persons:</b>
      <ul type="square">
        <li>
          Space must be provided for Advocates, from the middle of the room
          towards the dais, to come forward and present their arguments when
          their cases are being heard, including a dedicated space for
          government pleaders and public prosecutors;
        </li>
        <li>
          Space must be provided for the parties to be seated near their
          Advocates when their cases are being heard;
        </li>
        <li>
          Adequate accessible space must be provided for witnesses in a separate
          enclosed witness box to one side of the room near the dais; and
        </li>
        <li>
          Space must be designated for translators / interpreters and other
          support persons near the witness box.
        </li>
      </ul>
    </>,
    <>
      <b>Accused Persons:</b>
      <ul type="square">
        <li>
          Adequate accessible space must be provided for the Accused, in a
          separate enclosed box to the other side of the room, opposite the
          witness box; and
        </li>
        <li>
          Adequate accessible space must be designated for the police inspectors
          and accompanying security personnel near the Accused box.
        </li>
      </ul>
    </>,
    <>
      <b>General Public:</b>
      <ul type="square">
        <li>
          Adequate seating must be provided for others connected with the case
          and members of the public, towards the back of the Courtroom.{" "}
        </li>
      </ul>
    </>,
  ];

  const specificDesignConsider = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "The PDJ Courtroom must have segregated entrances for the Judge, lawyers, parties, and the Accused.",
      <>
        Adequate seating facilities must be provided as follows:
        {getCircleTypeListItem(specificItem, true)}
      </>,
      "Ramps, including portable ramps if required, must be provided at all instances of raised floor levels including the witness box, Accused box, and the access to the dais from the Courtroom and from the Judge’s chamber.",
      "Enclosed, compact storage space must be provided towards the back of the dais and wherever else feasible within the Courtroom..",
      "The Courtroom must be equipped with adequate technology for video-conferencing, mics, and case display monitors.",
    ],
    isOrdered: false,
    isImage: true,
  };

  const specificDesignConsider3 = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      <>
        The Family Courts Act provides for specific design considerations which
        must be kept in mind for designing Family Courts:
        <div style={{ paddingBottom: "15px" }}>
          <p className="table-guidance-heading">
            <span className="table-guidline-text">Table 5:</span>
            <br />
            <span style={tableCaption}>
              Design considerations arising from the Family Courts Act (1984).
            </span>
          </p>
          <Table5 />
        </div>
      </>,
      <>
        Additionally, provision should be made for a Family Visitation Room for
        the convenience of the parties. These rooms must provide a safe,
        private, and appropriate space for children to engage in visits with
        their family members. For further details about a child-friendly waiting
        area, refer to{" "}
        <span
          style={sectionStyle}
          onClick={() => goToSection("waitingArea", "generalWaiting")}
        >
          Sections 2.2.A.
        </span>{" "}
        and{" "}
        <span
          style={sectionStyle}
          onClick={() => goToSection("waitingArea", "familyWaiting")}
        >
          2.2.B.
        </span>
      </>,
    ],
    isImage: true,
  };

  const specificDesignConsider4 = [
    {
      icon: <img src={designConsideration} />,
      heading: "Specific Design Considerations",
      items: [
        <>
          The POCSO Act provides for specific design considerations which must
          be kept in mind for designing POCSO Courts:
          <div style={{ paddingBottom: "15px" }}>
            <p className="table-guidance-heading">
              <span className="table-guidline-text">Table 6:</span>
              <br />
              <span style={tableCaption}>
                Design considerations arising from the POCSO Act (2012).
              </span>
            </p>
            <Table6 />
          </div>
        </>,
        "The space must be designed with larger doors and windows (with necessary safety measures) to prevent the child feeling confined within the space.",
        <>
          The Courtroom must be located in a segregated section of the Court
          Complex, with separate pathways and facilities such as exclusive
          lifts.For further details, please refer to Vulnerable Witness
          Deposition Centres in{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("vwdc", "VWDC")}
          >
            Section 2.3.
          </span>
        </>,
        "Provision must be made for movable chairs within the Courtroom. This ensures that everyone involved, including the child victim, feels comfortable and appropriately placed during the legal proceedings.",

        "Wherever possible, level differences between the chairs used by the Judicial Officer, Advocates, and the child victim must be avoided or minimal. Efforts should be made in the design of the Courtroom to prevent any perceived hierarchy and physical distinctions that might contribute to the child victim feeling intimidated or inferior. It helps to create a more welcoming and less imposing atmosphere, allowing the child to feel more comfortable and empowered to participate in legal proceedings. ",

        <>
          Adequate acoustical materials must be used in the ceiling and wall to
          ensure the Courtroom does not get too loud. Maintaining an optimal
          acoustic environment fosters a sense of comfort and calmness, reducing
          stress and anxiety in the child victim. For further details on
          acoustics, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure4")}
          >
            {" "}
            Annexure 5.
          </span>
        </>,
        <>
          Dedicated seating space within the Courtroom must additionally be
          provided for the Special Public Prosecutor, family members or for
          other Support Persons accompanying the victim in close proximity to
          them. Provision should be made for seating of such support persons
          with the Courtroom.{reference(referenceData[12], 13)}
        </>,
      ],
    },
    {
      heading: "Additional Facilities with the POCSO Court",
      items: [
        <>
          A separate child-friendly waiting area must be provided. The waiting
          area must also be designed to be an open space with adequate natural
          lighting to ensure that the child does not feel confined within the
          space. For further details, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("waitingArea", "familyWaiting")}
          >
            {" "}
            Section 2.2.B.
          </span>
        </>,

        "Facilities such as a counselling/psychiatrist room must be made available for the dedicated use of the users of the special Courts",

        <>
          Separate and accessible facilities for toilets, drinking water, pantry,
          etc., must be provided. For further details, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() =>
              goToSection("sanitaryProvisions", "sanitaryProvisions")
            }
          >
            {" "}
            Section 3.1.
          </span>
        </>,

        "Children often cope with stress through play. The Courtroom must be adjacent to a green space such as playgrounds, seating areas, and age-appropriate amenities, considering the diverse needs and interests of children to ensure that they engage in recreational activities, fostering a sense of normalcy and providing a positive distraction from the Courtroom environment. This would further provide a relaxed setting, offering support and comfort before or after the legal proceedings.",

        <>
          Specific Principles of trauma-informed design considerations for
          vulnerable child witnesses must be followed while designing all spaces
          within the POCSO Court. For further details, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("vwdc", "vulnerable-witness")}
          >
            {" "}
            Section 2.3.A.
          </span>
        </>,
      ],
    },
  ];

  return (
    <div>
      <Typography>
        <h1 id="design-spaces" style={h1style}>
          PART C - THE HANDBOOK
        </h1>
        <h2 style={h2style}>
          <span style={{ fontSize: "24px" }}>2. </span>
          ORGANIZATION AND DESIGN OF SPACES OF THE COURT COMPLEX
        </h2>
        <h3 id="court-rooms" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.1. </span>
          Courtrooms
        </h3>
        <p style={paraStyle}>
          In a District Court Complex, each Judge requires a separate Courtroom.
          The size and design of each type of Courtroom varies according to the
          functions and activities that the Courtroom seeks to accommodate.
          These functions are largely determined by the types of cases that the
          Court hears:
        </p>
        {getTextContentHeading(courtHearsObject)}

        <p style={paraStyle}>
          At the District Court level, Judges are vested with both civil and
          criminal jurisdiction. Therefore, a Courtroom may be designed to
          accommodate both civil and criminal cases to be heard by a Judge, with
          separate Courtrooms being designed to accommodate Judges vested with
          special jurisdiction.
        </p>
        <p style={paraStyle}>
          This Handbook thus envisages two categories of Courtrooms:
        </p>
        {generateOrderedList(courtroomCategory)}

        <CaptionWithBorders1
          image={[RenderCourtroomsPDJ]}
          isZoom={true}
          caption="Figure 34: Users of the Courtroom"
          zoomImgStyle={{ height: "550px" }}
          imageDescription={FigureDesc34}
        />

        {getTextContentHeading(objectives)}
        {getTextContentHeading(usersObject)}
        {getTextContentHeading(adjacenciesObject)}
        {subHeadingContent(designConsiderationsObject)}

        <DividerBorderStyle />

        <h3 id="multipurpose" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.1.</span>A. Multipurpose
          Courtrooms
        </h3>
        <h3 style={subHeadingStyle} id="courtrooms-type-A">
          I. Courtroom Type-A (“PDJ Courtroom”)
        </h3>
        <p style={paraStyle}>
          The Court of the Principal District & Sessions Judge (“PDJ”) in each
          Court Complex is the highest Court in that District. The PDJ exercises
          both civil and criminal jurisdiction and is tasked with judicial and
          administrative control over the District Court Complex. The PDJ
          Courtroom is typically the largest Courtroom in the Complex, as the
          PDJ may hear cases brought directly before their Court in accordance
          with subject matter & pecuniary jurisdiction requirements as well as
          appeals in cases from other Judges in the District Court Complex. The
          PDJ may additionally be vested with special jurisdiction in some
          instances (eg: jurisdiction over cases under the Narcotic Drugs and
          Psychotropic Substances Act (1985)).
        </p>
        <p style={paraStyle}>
          The NCMS recommends that the typical Courtroom size must be at least{" "}
          <span style={dimensionStyle}>9.0 m x 16.0 m</span>. However, for the
          PDJ Courtroom, the size must be a minimum of{" "}
          <span style={dimensionStyle}>11.0 m x 10.0 m</span> to accommodate all
          of these functions.
        </p>

        <CaptionWithBorders1
          image={[courtroomTypeA]}
          isZoom={true}
          caption="Figure 36: Typical floor plan for Courtroom Type-A (PDJ Courtroom)"
          zoomImgStyle={{ height: "550px" }}
          imageDescription={FigureDesc36}
        />

        <CaptionWithBorders1
          image={[RenderCourtroomsPDJ]}
          isZoom={true}
          caption="Figure 37: Representation of the PDJ Courtroom"
          zoomImgStyle={{ height: "500px" }}
          imageDescription={FigureDesc37}
        />

        {getTextContentHeading(specificDesignConsider)}

        <h3 style={subHeadingStyle} id="courtroomtype-B">
          II. Courtroom Type-B (Other Judges)
        </h3>
        <p style={paraStyle}>
          At the District Court level, the following Judges also exercise
          jurisdiction over civil and criminal matters and report to the PDJ of
          that Court Complex, as shown below.
        </p>
        <CaptionWithBorders1
          image={[districtHierarchy]}
          isZoom={true}
          caption="Figure 38: Representation of hierarchy of District Court Judges in India"
          zoomImgStyle={{ height: "550px" }}
          imageDescription={FigureDesc38}
        />
        <p style={paraStyle}>
          The NCMS recommends that the typical Courtroom size for these Judges
          must be at least <span style={dimensionStyle}>7.0 m x 10.0 m</span>.
          However, the size must be a minimum of{" "}
          <span style={dimensionStyle}>11.0 m x 9.5 m</span> to accommodate all
          of the Court’s functions.
        </p>
        <div id="figure39">
          <CaptionWithBorders1
            image={[CourtroomTypeB]}
            isZoom={true}
            caption="Figure 39: Typical floor plan for Courtroom Type-B (Other Judges)"
            zoomImgStyle={{ height: "550px" }}
            imageDescription={FigureDesc39}
          />
        </div>

        <p style={paraStyle}>
          The Courtrooms for the other Judges at the District Court Complex must
          follow the same design considerations as that of the PDJ Courtroom.
        </p>

        <DividerBorderStyle />

        <h3 id="special-courtrooms" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.1.</span>B. Special Courtrooms
        </h3>

        <p style={paraStyle}>
            Certain legislations such as the Narcotic Drugs and Psychotropic
            Substances (NDPS) Act (1985),
          {reference(referenceData[5], 6)}{" "}
            Scheduled Castes and Scheduled Tribes (Prevention of Atrocities) Act
            (1989),
          {reference(referenceData[6], 7)} National Investigation Agency (NIA) Act (2008),
          {reference(referenceData[7], 8)}{" "}the Commercial Courts Act (2015),
          {reference(referenceData[8], 9)}{" "}
            the Juvenile Justice (Care and Protection of Children) Act (2015)
          {reference(referenceData[9], 10)}, etc., designate certain Courts as
          “Special Courts'', to ensure dedicated resources and speedy trial for
          offences under these Acts. Special Courts are often set up at, or in
          close proximity to, the District Court Complex.
        </p>
        <p style={paraStyle}>
          While the overall design considerations outlined above in{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("courtroom", "court-rooms")}
          >
            Section 2.1
          </span>{" "}
          would have to be followed for Special Courts as well, in some
          instances additional infrastructural requirements would have to be
          considered, based on the aims of the Act for which the Special Court
          has been established. For the purposes of the Handbook, two such
          Special Courts with distinct infrastructural requirements have been
          identified, as these Special Courts are often established in the same
          premises as the District Court Complex.
        </p>

        <h3 style={subHeadingStyle} id="courtroomtype-c">
          I. Courtroom Type-C (Family Court)
        </h3>
        <p style={paraStyle}>
          The Family Courts Act (1984) mandates dedicated Family Courts to be
          set up in every state.
          {reference(referenceData[10], 11)} Family Courts deal with disputes
          pertaining to marriage, family matters, and other connected issues.
        </p>
        <p style={paraStyle}>
          They may ideally be located within an integrated District Court
          Complex, for the convenience and ease of movement of litigants and
          lawyers.
        </p>

        {getTextContentHeading(specificDesignConsider3)}

        <DividerBorderStyle />
        <h3 style={subHeadingStyle} id="courtroom-type-d">
          II. Courtroom Type-D (POCSO Court)
        </h3>
        <p style={paraStyle}>
          The Protection of Children from Sexual Offences (“POCSO”) Act (2012)
          mandates the creation of Special Courts to try offences under the Act,
          for a speedy trial to ensure meaningful access to justice keeping in
          mind the best interests of the child. The POCSO Courtroom must be
          designed keeping in mind the psychological needs of the children who
          are the primary users of the space.
        </p>
        <p style={paraStyle}>
          The POCSO Courtroom must be designed to be utilised by a range of
          users, as the POCSO Act applies to any person under the age of
          eighteen.{reference(referenceData[11], 12)} This includes infants,
          toddlers, children, and teenagers. Hence, the “child-friendly” design
          of the space has to cater to a diverse range of ages, socio-cultural
          backgrounds, abilities, etc., Adequate provisions should also be
          provided for other users of the POCSO Courtroom which would include
          nursing mothers, the elderly, other support persons, etc.
        </p>
        <CaptionWithBorders1
          image={[pocsoCourtroom]}
          isZoom={true}
          caption="Figure 40: Typical floor plan for Courtroom Type-D (POCSO Courtroom)"
          zoomImgStyle={{ height: "550px" }}
          imageDescription={FigureDesc40}
        />

        {subHeadingContent(specificDesignConsider4)}

        <h2 ref={referencesRef} id="references" style={referenceStyle}>
          References
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default CourtRoomsPage;
